module.exports = __webpack_public_path__ + "static/media/recibo.5501dcd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/recibo.png
// module id = 241
// module chunks = 0